/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 *
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  accentColor?: string;
  className?: string;
}

// Two rings counter-rotating at different speeds - brand navy outer,
// brand teal inner. Replaces the old rotating-clock-face icon.
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 24,
  color = '#17212b',
  accentColor = '#45b6c6',
  className = ''
}) => {
  const borderWidth = Math.max(2, Math.round(size * 0.075));
  const innerInset = borderWidth + 4;

  return (
    <span
      className={`loading-spinner ${className}`}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    >
      <span
        className="loading-spinner__outer"
        style={{ borderWidth, borderTopColor: color, borderBottomColor: color }}
      />
      <span
        className="loading-spinner__inner"
        style={{ inset: innerInset, borderWidth, borderLeftColor: accentColor, borderRightColor: accentColor }}
      />
    </span>
  );
};

export default LoadingSpinner;
